"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ai-prompt-initial: Create an index file for the new match domain model directory to export the new rich model files.
 * @date: 2025-07-16
 */
/**
 * @ai-prompt-block: Consolidate all match-related model exports into this domain-specific index file to improve modularity and align with the project's domain-oriented architecture.
 * @date: 2025-07-16
 */
// Rich Models
__exportStar(require("./match.model"), exports);
__exportStar(require("./round.model"), exports);
__exportStar(require("./playerRound.model"), exports);
// Raw State and Types
__exportStar(require("./commentary/commentaryInfo"), exports);
__exportStar(require("./matchstate/matchState"), exports);
__exportStar(require("./matchstate/playerRoundState"), exports);
__exportStar(require("./matchstate/roundState"), exports);
__exportStar(require("./matchstate/teamState"), exports);
__exportStar(require("./matchstate/action"), exports);
__exportStar(require("./matchstate/gameAction"), exports);
__exportStar(require("./matchstate/matchStateErrors"), exports);
__exportStar(require("./matchstate/matchConstants"), exports);
__exportStar(require("./matchstate/contest"), exports);
__exportStar(require("../players/zones"), exports);
// Bots
__exportStar(require("./bots/bots"), exports);
